export const MAX_ATTEMPTS_REACHED = "MAX_ATTEMPTS_REACHED";